export default {
  TERRENO: 'Terreno',
  CASAOUAPARTAMENTO: 'CasaOuApartamento'
};